var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHomeIconContact(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18.17 18.17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#4ba647;}.cls-2{fill:none;stroke:#a0a0a0;stroke-miterlimit:10;stroke-width:0.5px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M11.62,13H9.91a.24.24,0,0,1-.24-.24v-1.2a.59.59,0,1,0-1.17,0v1.2a.24.24,0,0,1-.24.24H6.56a.25.25,0,0,1-.25-.24V9.41h-.9a.24.24,0,0,1-.22-.14.25.25,0,0,1,0-.27L8.91,5.25a.26.26,0,0,1,.35,0L11.1,7.13h0L12.93,9a.25.25,0,0,1,.05.27.23.23,0,0,1-.22.14h-.9v3.34A.24.24,0,0,1,11.62,13Zm-1.46-.49h1.21V9.17a.25.25,0,0,1,.25-.24h.56L9.09,5.77,6,8.93h.57a.24.24,0,0,1,.24.24V12.5H8v-.95a1.08,1.08,0,0,1,2.15,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M6.66,8.14l-.09,0a.25.25,0,0,1-.15-.22V6a.25.25,0,0,1,.24-.25h.72A.25.25,0,0,1,7.63,6v1.2a.28.28,0,0,1-.07.17l-.72.73A.25.25,0,0,1,6.66,8.14ZM6.91,6.2V7.3l.23-.24V6.2Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 9.09,
    cy: 9.09,
    r: 8.84
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeIconContact);
export default __webpack_public_path__ + "static/media/home-icon-contact.363bdd9d718b82bf60adf7e44d4d094a.svg";
export { ForwardRef as ReactComponent };